import {styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {ASSETS_URL} from '../../config.js';
import {STORY_WIDTH} from '../../constants.js';

const StyledVideo = styled('video')({
  width: '100%',
  height: '100%',
  maxWidth: STORY_WIDTH,
});

class Video extends Component {
  static propTypes = {
    story: PropTypes.object.isRequired,
    trackEvent: PropTypes.func.isRequired,
  };

  onEnded = event => {
    event.target.play();
    this.props.trackEvent('Loop completed');
  };

  render() {
    return (
      <StyledVideo
        muted
        controls
        autoPlay
        src={`${ASSETS_URL}/${this.props.story.id}/movie.mp4`}
        onEnded={this.onEnded}
      />
    );
  }
}

export default Video;
